import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';

import {TRIAL_END_PATH} from '../../../routes/paths';
import * as urls from '../../../util/urls';

export function ContactSalesCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="my-0 border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={urls.contactSalesPricing()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Talk to sales
        </TargetBlank>
      </Button>
    </div>
  );
}

export function ContactSupportCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex  items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={urls.contactSupportOther()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Talk to support
        </TargetBlank>
      </Button>
    </div>
  );
}

export function UpgradePlanCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={TRIAL_END_PATH}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Upgrade plan
        </TargetBlank>
      </Button>
    </div>
  );
}
